export const snakeToCamel = (str: string): string =>
  str?.replace(/_([a-z])/g, (_, c) => c.toUpperCase());

const isPlainObject = (val: unknown): val is Record<string, unknown> =>
  !!val && typeof val === "object" && val?.constructor === Object;

export const convertSnakeToCamel = <T>(data: T): T => {
  if (!data) return data;

  if (Array.isArray(data)) {
    // Safe cast through 'unknown' to avoid type clash
    return (data.map(convertSnakeToCamel) as unknown) as T;
  }

  if (isPlainObject(data)) {
    const result: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(data)) {
      result[snakeToCamel(k)] = convertSnakeToCamel(v);
    }
    return result as T;
  }

  return data;
};
